const binding = { modules: {}, dataActions: {} };

    (binding.modules['cus-account-icon'] = {
        c: () => require('partner/modules/cus-account-icon/cus-account-icon.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'cus-account-icon',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/cus-account-icon'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };